import { render } from "./DatePickerHeader.vue?vue&type=template&id=8f1cb49e"
import script from "./DatePickerHeader.vue?vue&type=script&lang=ts"
export * from "./DatePickerHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script